import { AxiosResponse } from "axios";
import AxiosService from "./Axios";
import BaseApi from "./BaseApi";

const OFFLINE_METRICS_DATA_FILE_URL_PREFIX = "/waveform-file";

class OfflineMetricsDataFileApi extends BaseApi {

    constructor() {
        super(OFFLINE_METRICS_DATA_FILE_URL_PREFIX);
    }

    public async getViewsByDeviceId(deviceId: string):  Promise<AxiosResponse<any>> {
        return AxiosService.get(`${OFFLINE_METRICS_DATA_FILE_URL_PREFIX}/views/device?deviceId=${deviceId}`);
    }

    public async queryViews(request: QueryOfflineMetricsDataFileViewRequest):  Promise<AxiosResponse<any>> {
        return AxiosService.post(`${OFFLINE_METRICS_DATA_FILE_URL_PREFIX}/view/query`, request);
    }

    public async upload(file: File):  Promise<AxiosResponse<any>> {
        const formData = new FormData();
        formData.append('file', file);
        return AxiosService.post(`${OFFLINE_METRICS_DATA_FILE_URL_PREFIX}/upload`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

}

interface QueryOfflineMetricsDataFileViewRequest {
    deviceId: string,
    startTime?: number,
    endTime?: number,
}


export default OfflineMetricsDataFileApi;
